import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom';

// const Dashboard = lazy(() => import('../../pages/dashboard'));
// const Ecommerce = lazy(() => import('../../pages/dashboard/Ecommerce'));
// const Business = lazy(() => import('../../pages/dashboard/Business'));
// const Performance = lazy(() => import('../../pages/dashboard/Performance'));
// const Sales = lazy(() => import('../../pages/dashboard/Sales'));
const CRM = lazy(() => import('../../pages/dashboard/CRM'));

function DashboardRoutes() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path} component={CRM} />
            {/* <Route path={`${path}/social`} component={Dashboard} />
      <Route exact path={`${path}/eco`} component={Ecommerce} />
      <Route exact path={`${path}/business`} component={Business} />
      <Route exact path={`${path}/performance`} component={Performance} />
      <Route exact path={`${path}/crm`} component={CRM} />
      <Route exact path={`${path}/sales`} component={Sales} /> */}
        </Switch>
    );
}

export default DashboardRoutes;
